import {createSelector} from 'reselect'
import get from 'lodash/get.js'

import {
  PO_DETAIL_ITEMS_PANEL,
  PO_DETAIL_PANELS,
  PURCHASE_ORDER_SINGLE_URI_COMPONENT,
} from '../../common/constants/PurchaseOrders.js'
import {
  EXPAND_MODE_COLLAPSED,
  EXPAND_MODE_EXPANDED,
} from '../../common/components/List/ExpandAllButton.js'
import {itemsSelector, activeGoodsReceiptsSelector} from '../../data/pos.js'
import {formsSelector} from '../../redux/selectors/ui/forms.js'
import {locationSelector} from '../../redux/selectors/ui/location.js'

export const PO_DETAIL_FORM = 'po_detail'

export const poDetailFormSelector = createSelector(
  formsSelector,
  (forms) => forms[PO_DETAIL_FORM],
)

export function selectedItemIDsSelector(state) {
  return get(poDetailFormSelector(state), 'selectedItemIDs', [])
}

export function expandedGoodsReceiptIDsSelector(state) {
  return get(poDetailFormSelector(state), 'expandedGoodsReceiptIDs', [])
}

export function goodsReceiptsExpandModeSelector(state) {
  return get(
    poDetailFormSelector(state),
    'goodsReceiptsExpandMode',
    EXPAND_MODE_EXPANDED,
  )
}

export const poItemsSelector = createSelector(
  (state) => {
    const poID = poIDSelector(state)

    return itemsSelector(state, {poID})
  },
  (poItems) => poItems,
)

export const poItemIDsSelector = createSelector(poItemsSelector, (poItems) =>
  poItems.map(({id}) => id),
)

export const poGoodsReceiptsSelector = createSelector(
  (state) => {
    const poID = poIDSelector(state)

    return activeGoodsReceiptsSelector(state, {poID})
  },
  (poGoodsReceipts) => poGoodsReceipts,
)

export const poGoodsReceiptIDsSelector = createSelector(
  poGoodsReceiptsSelector,
  (poGoodsReceipts) => poGoodsReceipts.map(({id}) => id),
)

export function poDetailURLSelector(state, {poID}) {
  return `#/${PURCHASE_ORDER_SINGLE_URI_COMPONENT}/${encodeURIComponent(poID)}`
}

export const poDetailLocationSelector = createSelector(
  locationSelector,
  (location) => {
    const {
      pathComponents: [resource],
    } = location

    const isThisPage = resource === PURCHASE_ORDER_SINGLE_URI_COMPONENT

    if (!isThisPage) {
      return null
    }

    return location
  },
)
export const poIDSelector = createSelector(
  poDetailLocationSelector,
  (location) => {
    if (!location) {
      return null
    }

    return location.pathComponents[1] || null
  },
)

export const currentPanelSelector = createSelector(
  poDetailLocationSelector,
  (location) => {
    if (!location) {
      return null
    }

    const panel = location.pathComponents[2]

    return PO_DETAIL_PANELS.includes(panel) ? panel : PO_DETAIL_ITEMS_PANEL
  },
)

export const areAllItemsSelectedSelector = createSelector(
  poItemsSelector,
  selectedItemIDsSelector,
  (poItems, selected) =>
    poItems.length > 0 && poItems.length === selected.length,
)

export const areIndeterminateItemsSelectedSelector = createSelector(
  areAllItemsSelectedSelector,
  selectedItemIDsSelector,
  (allSelected, selected) => !allSelected && selected.length > 0,
)

export const createIsGoodsReceiptExpandedSelector = (goodsReceiptID) =>
  createSelector(
    expandedGoodsReceiptIDsSelector,
    goodsReceiptsExpandModeSelector,
    (expandedReferenceIDs, expandMode) => {
      if (expandMode === EXPAND_MODE_COLLAPSED) {
        return expandedReferenceIDs.includes(goodsReceiptID)
      }
      if (expandMode === EXPAND_MODE_EXPANDED) {
        return !expandedReferenceIDs.includes(goodsReceiptID)
      }
      return false
    },
  )
